<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" by-operator :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('operatorRoutesStatsReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('operatorRoutesStatsReport.description') }}
      </p>
    </div>


    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && reportEnvelope" class="row ">
      <div class="col-6">
        <card :title="$t('operatorRoutesStatsReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorRoutesStatsReport.summary.operator') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.operatorName }}
                ({{ reportEnvelope.operatorId }})</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorRoutesStatsReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorRoutesStatsReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to |
                    dateOnly
                }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope && reportData" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`operatorRoutesStatsReport.results.title`) }}
            <small v-if="reportEnvelope" class="ml-2 text-muted">({{ reportEnvelope.from | dateOnly }} - {{
                reportEnvelope.to | dateOnly
              }})</small>
          </h4>
          <el-table row-key="id" :data="reportData" :empty-text="$t('generic.emptyReportForThePeriod')"
                    show-summary :summary-method="getRoutesStatsTableTotal">
            <el-table-column
              prop="vehicle_type"
              :label="$t(`operatorRoutesStatsReport.results.route`)">
              <template slot-scope="{ row }">
                <h5 v-if="row.route" class="d-inline">{{ row.route }}</h5>
                <span v-else>{{ row.period | dateOnly }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="journeys_count"
              :label="$t(`operatorRoutesStatsReport.results.journeys_count`)">
            </el-table-column>
            <el-table-column
              prop="charged"
              :label="$t(`operatorRoutesStatsReport.results.charged`)">
              <template slot-scope="{ row }">{{ row.charged | money }}</template>
            </el-table-column>
            <el-table-column
              :label="$t(`operatorRoutesStatsReport.results.vehicle_type`)">
              <template slot-scope="{ row }" v-if="row.vehicle_type">{{
                  $t(`transportTypes.transportType_${row.vehicle_type}`)
                }}
              </template>
            </el-table-column>
          </el-table>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import {mapActions, mapState} from "vuex";
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';
import ReportFilter from "./ReportFilter";

export default {
  name: 'routes-stats-report',
  components: {
    BasePagination,
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DetailedReportPeriod,
    ReportFilter
  },
  data() {
    return {
      report: null, // Received report data.
      reportEnvelope: null,
      reportData: [],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.operator_routes_stats_report.loading,
      error: state => state.operator_routes_stats_report.error,
      data: state => state.operator_routes_stats_report.data,
    }),
  },
  methods: {
    ...mapActions(['LoadOperatorRoutesStatsReport']),
    reloadReport(query) {
      this.LoadOperatorRoutesStatsReport(query);
    },
    getRoutesStatsTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t(`operatorRoutesStatsReport.results.summaryRow`);
          return;
        }

        if (index === 3) {
          sums[index] = '';
        } else {
          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }

          if (index === 2) {
            sums[index] = this.$options.filters['money'](sums[index])
          }
        }
      });

      return sums;
    },
    prepareReportData(report) {
      if (!report) {
        this.reportEnvelope = null;
        this.reportData = [];
        return
      }

      this.reportEnvelope = {
        from: report.from,
        to: report.to,
        generated_at: report.generated_at,
        operatorId: report.operatorId,
        operatorName: report.operatorName
      }

      this.reportData = report.data.map(item => {
        const r = {
          id: item.vehicle_type + item.route,
          vehicle_type: item.vehicle_type,
          route: item.route,
          journeys_count: 0,
          charged: 0,
          children: []
        }

        r.children = item.periods.map(period => {
          r.journeys_count = r.journeys_count + period.journeys_count;
          r.charged = r.charged + period.charged;

          period.id = r.id + period.period;
          period.title = period.period;
          // period.vehicle_type = r.vehicle_type;
          return period
        })

        return r
      })

      this.report = report;
    },
  },
  mounted() {
    this.prepareReportData(this.data)
  },
  watch: {
    data(report) {
      this.prepareReportData(report)
    },
  }
};
</script>
